import * as yup from 'yup';

export const validacaoFormImagens = yup.object().shape({
    nome: yup
        .string()
        .max(60, 'O nome da imagem deve ter no máximo 60 caracteres.')
        .required('Esse campo é obrigatório'),
    url: yup
        .string()
        .url('URL inválida')
        .max(999, 'O Link da imagem deve ter no máximo 999 caracteres')
        .required('Esse campo é obrigatório')
});
